module.exports = __webpack_public_path__ + "img/cup.3a1bb786.png";